const getUrlWithDeepRedirect = (baseAppUrl, deepRedirect) => {
  if (deepRedirect.includes('/team') || deepRedirect.includes('/user')) {
    return deepRedirect;
  }
  return baseAppUrl + deepRedirect;
};

export default getUrlWithDeepRedirect;
